import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sand">
        <div className="h-10 w-10 rounded-full iri-gradient animate-spin" style={{ maskImage: "radial-gradient(transparent 50%, black 51%)" }} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
